




























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import WearableCard from '@/components/WearableCard.vue';
import AlpacaCard from '@/components/AlpacaCard.vue';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import { getMyScarves, getMyOhterScarves } from '@/backend/requests';
import { OrderBy } from '@/backend/type';
import { Wearable, Alpaca } from '@/backend/type';
import { claim, wearableTypeClaimed } from '@/contract/wearableOperator';

@Component({
  components: {
    WearableCard,
    AlpacaBtn,
    AlpacaCard,
  },
})
export default class MyWearables extends Vue {
  @Prop({
    required: true,
    type: String,
  })
  public type!: string;

  public page: number = 1;
  public myWearables: Wearable[] = [];
  public myAlpacas: Alpaca[] = [];
  public stakeWearable: Wearable | null = null;
  public offset: number = 0;
  public limit: number = 20;
  public totalWearables: number = 0;
  public loaded: boolean = false;
  public wearableClaimed = true;

  get account() {
    return this.$store.getters.getAccount;
  }

  get hasWearables() {
    return this.totalWearables !== 0;
  }

  get pageNum() {
    if (this.totalWearables % this.limit === 0) {
      return this.totalWearables / this.limit;
    }
    return Math.floor(this.totalWearables / this.limit) + 1;
  }

  get inActivity() {
    return new Date().getTime() >= this.$store.getters.activity.start
    && new Date().getTime() <= this.$store.getters.activity.end;
  }

  public mounted() {
    this.getScarves();
  }

  public getScarves() {
    if (this.type === 'myScarves') {
      this.getMyScarves();
    }
    if (this.type === 'otherScarves') {
      this.getMyOtherScarves();
    }
  }

  public async getMyScarves(noEgg?: boolean) {
    const res = await getMyScarves(
      this.account,
      this.offset,
      this.limit,
    );
    if (res) {
      this.myWearables = res.data.wearables;
      this.totalWearables = res.data.total_count;
    }
    this.loaded = true;
  }

  public async getMyOtherScarves() {
    const res = await getMyOhterScarves(
      this.account,
      this.offset,
      this.limit,
    );
    if (res) {
      this.stakeWearable = res.data.stake_wearables;
      if (res.data.tailors) {
        this.myAlpacas = res.data.tailors.map((tailor: any) => tailor.alpaca);
      }
      this.totalWearables = res.data.tailors_count + (this.stakeWearable ? 1 : 0);
    }
    this.loaded = true;
  }

  public async getWearableTypeClaimed() {
    const claimed = await wearableTypeClaimed(this.account, 1);
    if (claimed) {
      // this.wearableClaimed = claimed;
      this.wearableClaimed = true;
    }
  }

  public changePage(page: number) {
    this.offset = (page - 1) * this.limit;
    this.getScarves();
  }

  public clickWearableCard(wearable: Wearable) {
    this.$emit('clickWearableCard', wearable);
  }

  public handleClaim() {
    claim(1, this.account);
  }

  @Watch('account', {immediate: true})
  public onAccount(val: string) {
    if (val) {
      this.getScarves();
      this.getWearableTypeClaimed();
    }
  }
}
